// pages/UpdateCategoryPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { alertSuccess, alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { categoryService, uploadService } from "@cabukaka/services";
import CategoryForm from "../../../components/features/categories/CategoryForm";
import { useToken, useSectors, useCategory } from "@cabukaka/hooks";
import useCustomParams from "../../../hooks/params/useCustomParams";
import { PageProps } from "../../../types/props/Props";

export default function UpdateCategoryPage({ }: PageProps) {
  const { id } = useCustomParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useToken();
  const { sectors } = useSectors();
  const { category: initialData } = useCategory({ id: id! })

  const generateSlug = (name: string) => {
    return name
      .toLowerCase()
      .trim()
      .replace(/[éèêë]/g, 'e')
      .replace(/[àâä]/g, 'a')
      .replace(/[îï]/g, 'i')
      .replace(/[ôö]/g, 'o')
      .replace(/[ùûü]/g, 'u')
      .replace(/[ç]/g, 'c')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  };

  const handleSubmit = async (data: { name: string; sectorId: string; imageFile?: File; existingImage?: string }) => {
    if (!id) return;
    if (!token) {
      alertError("Veillez vous connecter")
      return
    }

    setIsLoading(true);
    try {
      let imageUrl = data.existingImage || '';

      if (data.imageFile) {
        imageUrl = await uploadService.upload(data.imageFile, token!);
      }

      const slug = generateSlug(data.name);

      await categoryService.baseService.update(id, {
        name: data.name,
        slug,
        sectorId: data.sectorId,
        image: imageUrl
      } , token);

      alertSuccess("Catégorie modifiée avec succès");
      navigate(-1);
    } catch (error: any) {
      alertServerError(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!initialData) {
    return (
      <PageLayout title="Modifier la catégorie">
        <div className="flex justify-center py-20">Chargement...</div>
      </PageLayout>
    );
  }

  return (
    <PageLayout title="Modifier la catégorie">
      <PageContainer>
        <CategoryForm
          initialData={initialData}
          sectors={sectors}
          onSubmit={handleSubmit}
          isSubmitting={isLoading}
        />
      </PageContainer>
    </PageLayout>
  );
}